import { Vue, Component } from 'vue-property-decorator';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component
export default class CachePage extends Vue {
  beforeRouteLeave(to: any, from: any, next: any) {
    if (
      from &&
      from.meta.rank &&
      to.meta.rank &&
      from.meta.rank > to.meta.rank
    ) {
      // 此处判断是如果返回上一层，你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
      if (this.$vnode && (this.$vnode as any).data.keepAlive) {
        if (
          this.$vnode.parent &&
          this.$vnode.parent.componentInstance &&
          (this.$vnode.parent.componentInstance as any).cache
        ) {
          if (this.$vnode.componentOptions) {
            const key =
              this.$vnode.key == null
                ? (this.$vnode.componentOptions.Ctor as any).cid +
                  (this.$vnode.componentOptions.tag
                    ? `::${this.$vnode.componentOptions.tag}`
                    : '')
                : this.$vnode.key;
            const cache = (this.$vnode.parent.componentInstance as any).cache;
            const keys = (this.$vnode.parent.componentInstance as any).keys;
            if (cache.key) {
              if (keys.length) {
                const index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache.key;
            }
          }
        }
      }
      console.log('已摧毁上个页面:', from.name);
      this.$destroy();
    }
    next();
  }
}
